import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {DialogContentBase, DialogModule, DialogRef, KENDO_DIALOGS} from '@progress/kendo-angular-dialog';
import {EditorModule} from '@progress/kendo-angular-editor';
import {InputsModule} from '@progress/kendo-angular-inputs';
import {ButtonsModule} from '@progress/kendo-angular-buttons';
import {LabelModule} from '@progress/kendo-angular-label';
import {DropDownsModule} from '@progress/kendo-angular-dropdowns';
import {LayoutModule} from '@progress/kendo-angular-layout';
import {AutoFocusDirective} from '../../../directives/auto-focus.directive';
import {OrganisationDisciplineUserType, Role} from '../../../models/models.lib';
import {LoggerService} from '../../../shared/logger.service';
import {RolesService} from '../../../admin/roles.service';
import {CasiCloseOptions, FormModes} from '../../../common/constants.lib';

@Component({
  selector: 'casi-organisation-discipline-user-add.component',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    DialogModule,
    EditorModule,
    InputsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    LayoutModule,
    AutoFocusDirective,
    KENDO_DIALOGS
  ],
  templateUrl: './organisation-discipline-user-add.component.html',
  styleUrl: './organisation-discipline-user-add.component.scss'
})
export class OrganisationDisciplineUserAddComponent extends DialogContentBase implements OnInit {
  private _organisationDisciplineUser: OrganisationDisciplineUserType | undefined;

  @Input() title: string = 'Title Not Set';

  @Input({ required: true }) set organisationDisciplineUser(val: OrganisationDisciplineUserType) {
    this._organisationDisciplineUser = val;
    this.editForm.patchValue(this._organisationDisciplineUser);
  }
  get organisationDisciplineUser(): OrganisationDisciplineUserType | undefined {
    return this._organisationDisciplineUser;
  };

  private _mode: FormModes = FormModes.NOTSET;
  @Input({ required: true }) set mode(val: FormModes) {
    this._mode = val;
  }
  get mode(): FormModes {
    return this._mode;
  };

  get FormModes(): typeof FormModes {
    return FormModes;
  };

  editForm: FormGroup;
  roles: Role[] = [];

  constructor(
    public override dialog: DialogRef,
    private fb: FormBuilder,
    private logger: LoggerService,
    public dataService: RolesService,
  ) {
    super(dialog);
    this.editForm = this.fb.group(
      {
        id: [null, []],
        email: [null, [Validators.required, Validators.email]],
        organisation_discipline_id: [null, [Validators.required]],
        user_roles: [null, [Validators.required]]
      }
    );
  }

  //#region Form

  get f() {
    return this.editForm.controls;
  }
  get email() {
    return this.editForm.get('email');
  }

  get user_roles() {
    return this.editForm.get('user_roles');
  }
  //#endregion

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
    this.loadRoles();

    this.email?.valueChanges.subscribe(value => {
      if (value && value !== value.toLowerCase()) {
        this.email?.setValue(value.toLowerCase(), { emitEvent: false });
      }
    });
  }

  public onCancelAction(): void {
    this.logger.debug(`onCancelAction...`);
    this.dialog.close({ text: CasiCloseOptions.Cancelled });
  }

  public onSaveAction(): void {
    this.logger.debug(`onSaveAction...`, this.editForm.value);
    if (this.editForm.status !== 'INVALID')
      this.dialog.close({ text: CasiCloseOptions.Saved });
  }

  private loadRoles(): void {
    this.dataService.get().subscribe({
      next: data => this.roles = data ? data.filter((d: any) => d.can_select) : [],
      error: err => console.error('Failed to load roles', err)
    });
  }
}

